// IMPORTANT NOTE: 

// IF YOU HAVE CHANGES IN THIS FILE, PLEASE VERIFY THE CHANGES BECAUSE THIS FILE IS CONNECTED TO THE PAYMENT MODULE.
// AND YOUR CHANGES ARE REQUIRED. ALSO ADD YOUR CHANGES TO THE 'CHARGEBEE-SETUP' AND 'PADDLE-SETUP' FOLDER.

import { createRouter, createWebHashHistory } from 'vue-router'
import auth from './auth'
import projects from './projects'
import chat from './chat'
import settings from './settings'
import timesheet from './timesheet'
import milestonesheet from './milestonesheet'
import creative from './creative'
// 

import { useCustomComposable } from '@/composable'
import { App } from "realm-web";
const routes = [
	...auth,

	// PROJECT ROUTES
	...projects,

	// PROJECT ROUTES
	...chat,

	// SETTINGS ROUTES
	...settings,
	
	// TIMESHEET ROUTES
	...timesheet,

	//MILESTONE ROUTES
	...milestonesheet,

	// CREATIVE PRODUCTION WORKSPACE
	...creative,

	// 
	{
		path: "/",
		name: "Home",
		component: () => import(/* webpackChunkName: "home" */ '@/views/Home'),
		meta: {
			title: 'Home',
			requiresAuth: true,
		}
	}, {
		path: "/:catchAll(.*)",
		name: "404",
		component: () => import(/* webpackChunkName: "404" */ '@/views/NotFound'),
		meta: {
			title: '404'
		}
	}
	// 
]

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes
})

// const authInst = getAuth();
const jsonData = require('../../../brandSettings.json');
const {setTitle} = useCustomComposable()
router.beforeEach((to, _, next) => {
	if (to.query?.detailTab && !to.params?.taskId) {
		const query = { ...to.query };
		delete query.detailTab;
		next({ path: to.path, query, hash: to.hash, replace: true });
		return;
	}
	if (!process.env.VUE_APP_MONGO_APP_ID) {
		setTitle({title: to.meta.title, prefix: jsonData?.productName ? `${jsonData.productName} | ` : ''});
		next();
		return;
	}
	const app = new App({ id: process.env.VUE_APP_MONGO_APP_ID });
	let user = app.currentUser;
	// onAuthStateChanged(authInst, (user) => {
		// CHECK META FOR AUTH REQUIRED
		// const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
		const requiresAuth = to.meta.requiresAuth;

		// SET PAGE TITLE
		setTitle({title: to.meta.title, prefix: jsonData?.productName ? `${jsonData.productName} | ` : ''});

		if(user === null && requiresAuth === true) {
			// IF USER IS NOT LOGGED IN AND REQUESTS AUTH REQUIRED PAGE
			next({name: 'Log-in', query: {redirect_url: to.fullPath}});
			return;
		} else if(user !== null && requiresAuth === false && to.meta.allowAuthenticated !== true) {
			// IF USER IS LOGGED IN AND REQUESTS NO AUTH REQUIRED PAGE
			if(to.meta.title === 'Support'){
				next();
			}else{
				next({name: "Home"});
			}
			return;
		} else {
			next();
			return;
		}
	// })
})

export default router;
